import { Middleware, MiddlewareAPI } from 'redux'
import { AppAction, AppState } from '../types';
import { Urls } from '../components/Sidebar/Urls';
import { artifact } from './actions';

declare var analytics: any;

type Item = {
  type: string
  alias: string
  transform: (state: AppState, action: AppAction) => any
  transformAlias?: (data: any) => any
}

const list: Item[] = [];

const add = (item: Item) => {
  const type = typeof item.type;
  if (type !== 'string') {
    throw new TypeError(`segment: Expect type to be a string. Got ${type} ${item.type}`);
  }

  if (item.transform) {
    const transformType = typeof item.transform;
    if (transformType !== 'function') {
      throw new TypeError(
          `segment: Expect transform to be a function. Got ${transformType} ${item.transform}`
      );
    }
  }

  list.push(item);
};

export const track = (type: string, alias: string,
                      transform: (state: AppState, action: AppAction) => any,
                      transformAlias?: (data: any) => any) => {
  add({type, alias, transform, transformAlias});
};

const processAction = (state: AppState, action: AppAction) => {
  const {type} = action;
  const item = list.find(a => a.type === type);

  if (item) {
    const data = (item.transform ? item.transform(state, action) : {}) || {};
    const segmentType = item.transformAlias ? item.transformAlias(data) : (item.alias || type);
    if (window.analytics) {
      analytics.track(`Monitoring Center - ${segmentType}`, data);
    }
  }
};

export const middleware: Middleware = ({getState}: MiddlewareAPI<any>) => (next: any) => (action: any) => {
  const state = getState();
  processAction(state, action);
  return next(action);
};

const nameFromHash = (hash: string = '') => {
  const newURL = hash.split('/')
  const first = newURL[0]
  const last = newURL.length <= 1 ? false : newURL[newURL.length - 1].split('?')[0]

  switch ('/' + first) {
    case Urls.builtIn:
      // return last ? `Builtin Dashboard - ${last}` : 'Builtin Dashboard - Home'
      return last ? 'Builtin Dashboard - Page' : 'Builtin Dashboard - Home'
    case Urls.customDashboardPage:
      return last ? 'Custom Dashboard - Page' : 'Custom Dashboard - List'
    case Urls.newCustomDashboard:
      return 'Custom Dashboard - New'
    case Urls.alerts:
      return 'Alerts'
    case Urls.logs:
      return 'Logs'
    case Urls.rawData:
      return 'Raw Data'
    case Urls.tools:
      return 'Tools'
    case Urls.apitesting:
      return 'API Testing'
    case Urls.reports:
      return 'Reports'
    case Urls.settings:
      return 'Settings'
    case Urls.logPoints:
      return 'Log Points'
    case Urls.customMetrics:
      return 'Custom Metrics Tools'
    default:
      return ''
  }
};

let currentPage: any = null;
const pageEvent = (hash: string = location.hash.replace('#/', '')) => {
  const name = nameFromHash(hash);
  if (name) {
    const pageName = `Monitoring Center - ${name}`;
    if (!currentPage || currentPage.name !== pageName) {
      const q = hash.indexOf('?');
      const pageEvent = {
        name: pageName,
        url: document.URL,
        path: q === -1 ? hash : hash.substring(0, q),
        search: q === -1 ? '' : hash.substring(q + 1),
        referrer: currentPage ? currentPage.url : '',
        referrerName: currentPage ? currentPage.name : '',
        artifact: artifact
      };
      if (window.analytics) {
        analytics.page(pageEvent.name, pageEvent)
        // analytics.track(pageEvent.name, {artifact: artifact, payload: pageEvent})
      }
      currentPage = pageEvent
    }
  }
};

window.addEventListener('hashchange', () => pageEvent());
pageEvent();
